import axios from 'axios'
import { ENTRYPOINT } from '../../../config/entrypoint'
import * as types from './mutation_types'
import FileSaver from 'file-saver'

export const setData = ({ commit }, payload) => {
  commit(types.SET_DATA, payload)
}

export const setStyle = ({ commit }, payload) => {
  commit(types.SET_STYLE, payload)
}

export const setIsCloningFormat = ({ commit }, payload) => {
  commit(types.IS_CLONING_FORMAT, payload)
}

export const setIsSelectingColor = ({ commit }, payload) => {
  commit(types.IS_SELECTING_COLOR, payload)
}

export const setMetadata = ({ commit }, payload) => {
  commit(types.SET_METATDATA, payload)
}

export const setListOnglet = ({ commit }, payload) => {
  commit(types.SET_LIST_ONGLET, payload)
}

export const getPermissions = ({ commit }, payload) => {
  commit(types.SET_PERMISSION, payload)
}

export const setFiches = ({ commit }, payload) => {
  commit(types.SET_FICHES, payload)
}

export const setCurrentOnglet = ({ commit }, payload) => {
  commit(types.SET_CURRENT_ONGLET, payload)
}

export const setCurrentProject = ({ commit }, payload) => {
  commit(types.SET_CURRENT_PROJECT, payload)
}

export const setIsProjectTemplate = ({ commit }, value) => {
  commit(types.IS_PROJECT_TEMPLATE, value)
}

export const setCurrentBorderWidth = ({ commit }, payload = null) => {
  if (!payload) {
    commit(types.SET_CURRENT_BORDER_WIDTH, JSON.parse(localStorage.getItem('border_style')).borderWidth)
  } else {
    commit(types.SET_CURRENT_BORDER_WIDTH, payload)
    const temp = { ...JSON.parse(localStorage.getItem('border_style')), borderWidth: payload }
    localStorage.setItem('border_style', JSON.stringify(temp))
  }
}

export const setCurrentBorderColor = ({ commit }, payload = null) => {
  if (!payload) {
    commit(types.SET_CURRENT_BORDER_COLOR, JSON.parse(localStorage.getItem('border_style')).borderColor)
  } else {
    commit(types.SET_CURRENT_BORDER_COLOR, payload)
    const temp = { ...JSON.parse(localStorage.getItem('border_style')), borderColor: payload }
    localStorage.setItem('border_style', JSON.stringify(temp))
  }
}

export const getTypeDonnees = async ({ commit, state }) => {
  try {
    if (!state.typeDonnes) {
      const resp = await axios({ url: ENTRYPOINT + '/api/type-donnee/liste', method: 'GET' })
      commit(types.SET_TYPE_DONNEES, resp.data.data)
    }
  } catch (e) {
    return e.response.data.message
  }
}

export const deleteTypeDonnes = async ({ commit, state }, id) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/type-donnee/supprime/' + id, method: 'DELETE' })
    return 'Suppression effectuée'
  } catch (err) {
    return err.response.data.message
  }
}

export const updateTypeDonnees = async ({ commit }, { id, data }) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/type-donnee/maj/' + id, data, method: 'POST' })
    return 'Mise à jour type effectuée'
  } catch (err) {
    return err.response.data.message
  }
}

export const addTypeDonnees = async ({ commit }, data) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/type-donnee/ajout', data, method: 'POST' })
    return 'Ajout type effectuée'
  } catch (err) {
    return err.response.data.message
  }
}

export const projectsListById = async ({ commit }, socId) => {
  let clientId = 0
  try {
    const resp = await axios({ url: ENTRYPOINT + '/api/projets/liste/' + socId + '/' + clientId + '?page=0', method: 'GET' })
    commit(types.SET_PROJECTS_LIST, resp.data.data.items)
  } catch (err) {
    return err
  }
}

export const getTableauxListById = async ({ commit }, projectId) => {
  try {
    const resp = await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/liste/' + projectId + '?page=0', method: 'GET' })
    commit(types.SET_TABLEAUX_LIST, resp.data.data.items)
  } catch (err) {
    return err
  }
}

export const setDisabledAddTableau = ({ commit }, data) => {
  commit(types.DISABLED_ADD_TABLEAU, data)
}

export const setEspaceFromTableau = async ({ commit }, ongletId) => {
  try {
    const resp = await axios({ url: ENTRYPOINT + '/api/tableau-surface/dupliquer/onglet/' + ongletId, method: 'GET' })
    let espaces = resp.data.data.data.filter((item, index) => {
      if (index !== 0) {
        if (item[0] !== '' && item[1] !== '') {
          return item
        }
      }
    })
    commit(types.SET_ESPACE_FROM_TABLEAU, espaces)
  } catch (err) {
    return err.response.data.message
  }
}

export const getTableauById = async ({ commit }, ongletId) => {
  try {
    const resp = await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/' + ongletId, method: 'GET' })
    commit(types.SET_TABLEAU_BY_ID, resp.data.data)
  } catch (err) {
    return err.response.data.message
  }
}

export const getListOnglet = async ({ commit, state }, projectId) => {
  try {
    if (!state.listOnglet || !state.currentProject || state.currentProject !== projectId) {
      const resp = await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/liste/' + projectId, method: 'GET' })
      commit(types.SET_CURRENT_PROJECT, projectId)
      commit(types.SET_LIST_ONGLET, resp.data.data.items)
      commit(types.SET_PERMISSION, resp.data.data.getPermissions)
      commit(types.SET_FICHES, resp.data.data.fiches)
    }
  } catch (err) {
    return err.response.data.message
  }
}

export const getTableauData = async ({ commit }, ongletId) => {
  try {
    const resp = await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/' + ongletId, method: 'GET' })
    commit(types.SET_CURRENT_ONGLET, ongletId)
    return resp.data.data
  } catch (err) {
    return err.response.data.message
  }
}

export const updateOngletTitre = async ({ commit }, data) => {
  try {
    const resp = await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/modification-attributs/' + data.id, data, method: 'POST' })
    return resp.data.data.items
  } catch (err) {
    return err.response.data.message
  }
}

export const addOnglet = async ({ commit, state }, data) => {
  try {
    const resp = await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/ajout', data, method: 'POST' })
    commit(types.SET_LIST_ONGLET, [...state.listOnglet, resp.data.data])
  } catch (err) {
    return err.response.data.message
  }
}

export const deleteOnglet = async ({ commit, state }, data) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/supprime/' + data, method: 'DELETE' })
    const index = state.listOnglet.findIndex(el => el.id === data)
    commit(types.SET_LIST_ONGLET, state.listOnglet.filter(el => el.id !== data))
    if (state.currentOnglet === data) {
      if (index > state.listOnglet.length - 1) {
        commit(types.SET_CURRENT_ONGLET, state.listOnglet[index - 1].id)
      } else {
        commit(types.SET_CURRENT_ONGLET, state.listOnglet[index].id)
      }
    }
    return 'Onglet supprimé'
  } catch (err) {
    return err.response.data.message
  }
}

export const saveTableauSurfaces = async ({ commit, state }, data) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/modification/' + data.id, data, method: 'POST' })
    return 'Sauvegardé'
  } catch (err) {
    return err.response.data.message
  }
}

export const modificationAttributOnglet = ({ commit }, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const resp = await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/modification-attributs/' + data.id, data, method: 'POST' })
      resolve(resp.data.data.items)
    } catch (err) {
      reject(err.response.data.message)
    }
  })
}

export const getColumnsDescription = async ({ commit }, ongletId) => {
  try {
    const resp = await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/headers-columns/' + ongletId, method: 'GET' })
    return resp.data.data
  } catch (err) {
    return err.response.data.message
  }
}

export const setIsCopied = ({ commit }, data) => {
  commit(types.IS_COPIED, data)
}

export const setShowType = ({ commit }, data) => {
  commit(types.SHOW_TYPE, data)
}

export const exportTableau = async ({ commit }, idonglet) => {
  try {
    const xlsx = await axios({ url: ENTRYPOINT + '/api/tableau-surface/onglet/export/' + idonglet, method: 'GET', responseType: 'blob' })
    console.log(xlsx.headers['content-disposition'].split('"')[1])
    FileSaver.saveAs(xlsx.data, xlsx.headers['content-disposition'].split('"')[1])
    return true
  } catch (err) {
    return false
  }
}

// mode invité

export const setAccess = async ({ commit }, payload) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/invitation/envoi', data: payload, method: 'POST' })
  } catch (err) {
    return false
  }
}

export const saveChoices = async ({ commit }, payload) => {
  try {
    await axios({ url: ENTRYPOINT + '/api/invitation/envoi', data: payload, method: 'POST' })
  } catch (err) {
    return false
  }
}

export const getListAccess = async ({ commit }, payload) => {
  try {
    const access = await axios({ url: ENTRYPOINT + '/api/invitation/liste', data: payload, method: 'POST' })
    return access
  } catch (err) {
    return false
  }
}

export const deleteInvitation = async ({ commit }, idInvitation) => {
  try {
    const res = await axios({ url: ENTRYPOINT + '/api/invitation/supprime/' + idInvitation, method: 'DELETE' })
    return res
  } catch (err) {
    return false
  }
}

// page readOnlyTableau

export const setInviteToken = ({ commit }, token) => {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

export const getInviteListOnglet = async ({ commit, state }, payload) => {
  try {
    if (!state.listOnglet || !state.currentProject || state.currentProject !== payload.projectId) {
      const resp = await axios({ url: ENTRYPOINT + '/invite/tableau-surface/onglet/liste/' + payload.projectId + '?invitation=' + payload.idInvitation, method: 'GET' })
      commit(types.SET_CURRENT_PROJECT, payload.projectId)
      commit(types.SET_LIST_ONGLET, resp.data.data.items)
      commit(types.SET_PERMISSION, resp.data.data.tableau_invitation)
      commit(types.SET_FICHES, resp.data.data.fiches)
    }
  } catch (err) {
    return err.response.data.message
  }
}

export const getInviteTableauData = async ({ commit }, obj) => {
  try {
    const resp = await axios({ url: ENTRYPOINT + '/invite/tableau-surface/onglet/' + obj.onglet + '?invitation=' + obj.invit, method: 'GET' })
    commit(types.SET_CURRENT_ONGLET, obj.onglet)
    return resp.data.data
  } catch (err) {
    return err.response.data.message
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tableau/actions.js